// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","primary":"primary--2W8vn","success":"success--1kSVy","error":"error--3sWMl"};